module.exports = __webpack_public_path__ + "img/knue_gallery9.0b11762b.jpg";